import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import {
    createChallengeAPI,
    featuredChallengesAPI,
    getPartnerChallenges,
    updateChallengeAPI,
} from '../../../api';
import { challengesSucceeded } from '../../Challenges/actions';
import {
    createChallengeFailed,
    createChallengeSucceeded,
    featuredChallengeSucceeded,
} from './actions';
import {
    CREATE_CHALLENGE_REQUESTED,
    FEATURED_CHALLENGE_REQUESTED,
} from './constants';
import { uploadImage } from '../../../helpers/uploadImageToAWS';
import { parseClientError } from '../../../api/utils';

function* createChallenge(action) {
    try {
        let request = action.requestedChallenge;
        request.memberTarget =
            request.memberTarget === '' ? null : request.memberTarget;
        if (request.banner && typeof request.banner !== 'string')
            request.banner = yield call(uploadImage, {
                target: { files: request.banner },
            });
        let challenge;
        if (request.id) {
            challenge = yield call(updateChallengeAPI, request);
        } else {
            challenge = yield call(createChallengeAPI, request);
        }
        yield put(createChallengeSucceeded(challenge));
        const challenges = yield call(getPartnerChallenges);
        yield put(challengesSucceeded(challenges));
    } catch (err) {
        Sentry.captureException(err);
        const error = parseClientError(err);
        const message = error && error.message ? error.message : error;
        yield put(createChallengeFailed(message));
    }
}

function* getFeaturedChallenge(actions) {
    try {
        let search = actions.search;
        let challenges = yield call(featuredChallengesAPI, { search });
        yield put(featuredChallengeSucceeded(challenges));
    } catch (err) {
        Sentry.captureException(err);
        console.log(err);
        yield put(createChallengeFailed(err));
    }
}

export default function*() {
    yield all([yield takeLatest(CREATE_CHALLENGE_REQUESTED, createChallenge)]);
    yield all([
        yield takeLatest(FEATURED_CHALLENGE_REQUESTED, getFeaturedChallenge),
    ]);
}
